import { ForwardedRef, ReactNode, forwardRef } from 'react';
import styled from 'styled-components';

export const IconButton = forwardRef(
  (
    {
      children,
      handleClick,
      isActive,
      isTriangleLeft,
      isTriangleRight,
    }: {
      children: ReactNode;
      handleClick?: () => void;
      isActive?: boolean;
      isTriangleRight?: boolean;
      isTriangleLeft?: boolean;
    },
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    return (
      <Container
        ref={ref}
        $active={isActive}
        $triangleLeft={isTriangleLeft}
        $triangleRight={isTriangleRight}
        onClick={handleClick}
      >
        {children}
      </Container>
    );
  }
);

const Container = styled.div<{
  $active?: boolean;
  $triangleLeft?: boolean;
  $triangleRight?: boolean;
}>`
  user-select: none;
  position: relative;
  cursor: pointer;

  width: 40px;
  height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 10px;

  color: var(--text-color-secondary);
  transition:
    background-color 0.3s ease,
    color 0.3s ease;

  &:hover {
    color: var(--text-color);
    background-color: var(--panel-bg-color-hover);
  }

  &:active {
    color: var(--accent-color-secondary);
  }

  & > i {
    font-size: 24px;
  }

  & > span {
    box-sizing: border-box;
    min-width: 100%;
    position: absolute;
    bottom: 0;
    padding: 0 2px;

    text-align: center;
    border-radius: 20px;
    background-color: var(--panel-bg-color-secondary);

    font-size: 10px;
    font-weight: 500;

    transition: background-color 0.3s ease;
  }

  ${({ $triangleLeft, $triangleRight }) =>
    $triangleRight
      ? `
      &::after {
        content: '';
        pointer-events: none;
        position: absolute;
        right: 0;
      
        border-top: 20px solid transparent;
        border-bottom: 20px solid transparent;
        border-left: 0px solid var(--panel-bg-color);
      
        transition: border-left-width .3s ease, right .3s ease;
      }
    `
      : $triangleLeft &&
        `
      &::after {
        content: '';
        pointer-events: none;
        position: absolute;
        left: 0;
      
        border-top: 20px solid transparent;
        border-bottom: 20px solid transparent;
        border-right: 0px solid var(--panel-bg-color);
      
        transition: border-right-width .3s ease, left .3s ease;
      }
    `}

  ${({ $active, $triangleLeft, $triangleRight }) =>
    $active &&
    `
      color: var(--accent-color);
      background-color: var(--panel-bg-color-secondary);

      &:hover {
        color: var(--accent-color);
      }
      & > i {
        animation: .3s bounce;
      }
      & > span {
        color: var(--panel-bg-color);
        background-color: var(--accent-color) !important;
      }

      ${
        $triangleRight
          ? `
          &::after {
            right: -17px;
            border-left-width: 15px;
          }
        `
          : $triangleLeft &&
            `
          &::after {
            left: -17px;
            border-right-width: 15px;
          }
        `
      }
    `}
`;
